import ServiceBase from './ServiceBase'

class InquiryService extends ServiceBase {
  async queryMine(params: { page: number; size: number }) {
    const apiUrl = 'information/inquiry/queryMine'
    return new Promise<any>((resolve, reject) => {
      this.webPost(
        params,
        (res) => {
          resolve(res)
        },
        apiUrl,
        (err) => {
          reject(err)
        }
      )
    })
  }
  async findTopicById(inquiryId: number) {
    const apiUrl = 'information/inquiry/topicByInquiry&id='+inquiryId
    return new Promise<any>((resolve, reject) => {
      this.webGet(
        {
          params: {
            id: inquiryId
          }
        },
        (res) => {
          resolve(res)
        },
        apiUrl,
        (error) => {
          reject(error)
        }
      )
    })
  }

  async saveHelpDeskNotes(params: { orderId: number; msgType: string; msgContent: string }) {
    const apiUrl = 'common/helpdesk/saveNotes'
    return new Promise((resolve, reject) => {
      this.webPost(
        { params },
        (res) => {
          resolve(res)
        },
        apiUrl,
        (err) => {
          reject(err)
        }
      )
    })
  }
}

export default new InquiryService()
